export default __webpack_public_path__ + "static/media/keke_cv.23002df5.pdf";